module.exports = __webpack_public_path__ + "img/1.a488bad0.png";